import { AxiosResponse } from 'axios';
import { ClaimResponse } from '../types/claim';
import { EntityResponse } from '../types/entityDefinitions';
import { Policy2, QuoteResponse } from '../types/policy';
import { getApiUrl } from '../util/util';
import { get } from './http';

export interface SearchResultResponse {
	results: Result[];
}

export type ResultEntityType =
	| 'entity.policyholder'
	| 'entity.policy2'
	| 'entity.claim3'
	| 'entity.new.business.policy.quote';

export interface Result {
	entityType: ResultEntityType;
	entity?: EntityResponse;
	policy2?: Policy2;
	claim3?: ClaimResponse;
	policyQuote?: QuoteResponse;
	gracePeriodStart?: string;
}

interface SearchApi {
	search(
		authorizationToken: string,
		queryString: string,
	): Promise<AxiosResponse<SearchResultResponse>>;
}

export default {
	search(authorizationToken: string, queryString: string) {
		return get(
			`${getApiUrl()}/entity/v1/search/frontend?query=${encodeURI(
				queryString,
			)}`,
			authorizationToken,
		);
	},
} as SearchApi;
